import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { CartItemProduct } from "@omni/types/api/cart/bff/shared/cartItemProduct.model";
import { ModelMapper } from "@omni/types/utils/modelMapper";

import { translateWithoutContext } from "@/redux/modules/value/translations/translations.helpers";

const getTitleClientSide = (model: CartItemProduct, cartItem: CartItem) => {
    if (cartItem.warrantyDeposit) {
        return translateWithoutContext("general.product.pallet.title");
    }

    return model.productTitle;
};

const CartItemProductMapper: ModelMapper<
    CartItemProduct,
    (cartItem: CartItem) => CartItemProduct
> = (model) => {
    return (cartItem: CartItem) => ({
        ...model,
        productTitle: getTitleClientSide(model, cartItem)
    });
};

const CartItemMapper: ModelMapper<CartItem, CartItem> = (model) => {
    return {
        ...model,
        product: model.product
            ? CartItemProductMapper(model.product)(model)
            : undefined
    };
};

export const CartMapper: ModelMapper<Cart, Cart> = (model) => {
    return {
        ...model,
        items: model.items.map(CartItemMapper)
    };
};
